import {
  groupedCardsKeymap,
  insertGroupedCardsCommand,
  ungroupCardsCommand,
} from './groupedCardsCommands';
import { groupedCardsNode } from './groupedCardsNode';
import { groupedCardsRemark } from './groupedCardsRemark';
import { groupedCardsView } from './groupedCardsView';

/**
 * Grouped Cards Plugin for Milkdown.
 *
 * Provides first-class support for grouped-cards in the editor.
 *
 * Usage:
 * ```typescript
 * import { groupedCardsPlugin } from './plugins/groupedCards';
 *
 * const crepe = new Crepe({ ... });
 * crepe.editor.use(groupedCardsPlugin);
 * ```
 *
 * Current Status (Phase 4 MVP):
 * - ✅ Basic node definition with HTML parsing
 * - ✅ React view component with visual container
 * - ✅ Insert and ungroup commands
 * - ✅ Keyboard shortcuts (Cmd+Shift+G, Cmd+Shift+U)
 * - TODO: Enhanced parser for markdown HTML blocks
 * - TODO: Update CardToolbar to use insert command
 */
export const groupedCardsPlugin = [
  groupedCardsRemark,
  groupedCardsNode,
  groupedCardsView,
  insertGroupedCardsCommand,
  ungroupCardsCommand,
  groupedCardsKeymap,
].flat();

// Export individual pieces for testing
export {
  groupedCardsKeymap,
  groupedCardsNode,
  groupedCardsRemark,
  groupedCardsView,
  insertGroupedCardsCommand,
  ungroupCardsCommand,
};
